/**
 * Client-side UTM utility functions
 */

/**
 * Convert campaign name to URL-safe slug for utm_campaign parameter
 * @param {string} campaignName - The campaign name
 * @returns {string} - URL-safe slug
 */
export function generateUtmCampaignSlug(campaignName) {
  if (!campaignName) {
    return 'campaign';
  }

  return campaignName
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove non-word chars except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/--+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Trim hyphens from start and end
}
